export const BOUNCER_ADDRESS = '0x6EBb3ee743f3ad0eAd30DE88B1351C88C8f38886'

export const BOUNCER_ABI = [
  {
    "name": "BuildBouncer",
    "inputs": [
      {
        "name": "myAddress",
        "type": "address",
        "indexed": false
      },
      {
        "name": "receiverAddress",
        "type": "address",
        "indexed": false
      },
      {
        "name": "myBounceAddress",
        "type": "address",
        "indexed": false
      }
    ],
    "anonymous": false,
    "type": "event"
  },
  {
    "stateMutability": "nonpayable",
    "type": "constructor",
    "inputs": [],
    "outputs": []
  },
  {
    "stateMutability": "payable",
    "type": "function",
    "name": "buildBouncer",
    "inputs": [
      {
        "name": "_receiverAddress",
        "type": "address"
      }
    ],
    "outputs": [],
    "gas": 94300
  },
  {
    "stateMutability": "view",
    "type": "function",
    "name": "bounceContract",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "gas": 2418
  },
  {
    "stateMutability": "view",
    "type": "function",
    "name": "myBouncer",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "gas": 2448
  }
]

export const BOUNCE_ABI = [
  {
    "stateMutability": "nonpayable",
    "type": "constructor",
    "inputs": [],
    "outputs": []
  },
  {
    "stateMutability": "payable",
    "type": "function",
    "name": "bounceONE",
    "inputs": [
      {
        "name": "_myAddress",
        "type": "address"
      },
      {
        "name": "_receiverAddress",
        "type": "address"
      }
    ],
    "outputs": [],
    "gas": 72652
  },
  {
    "stateMutability": "nonpayable",
    "type": "function",
    "name": "grabONE",
    "inputs": [],
    "outputs": [],
    "gas": 27468
  },
  {
    "stateMutability": "nonpayable",
    "type": "function",
    "name": "bounceBackONE",
    "inputs": [],
    "outputs": [],
    "gas": 27498
  },
  {
    "stateMutability": "view",
    "type": "function",
    "name": "myAddress",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "gas": 2478
  },
  {
    "stateMutability": "view",
    "type": "function",
    "name": "receiverAddress",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "gas": 2508
  }
]
